import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Borett from './Borett'
import EierforholdIcon from '../../../images/Eierforhold.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class BorettList extends Component {
    state = {
        boretter: [],
        isLoading: false,
        isBoretterLoaded: false,
        isOpened: false,
        continuationToken: null
    }

    getBoretter = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/borett`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                boretter: [...this.state.boretter, ...data.boretter].sort(this.bolignummerComparer),
                isLoading: false,
                isBoretterLoaded: true,
                continuationToken: data.nextContinuationToken
            })
        })
      }

      bolignummerComparer = (a, b) => {
        if (a.adressenavn != null && b.adressenavn != null && a.adressenavn != b.adressenavn) {
            if (a.adressenavn > b.adressenavn) return 1
            if (a.adressenavn < b.adressenavn) return -1
        }

        if (a.nummer != null && b.nummer != null && a.nummer != b.nummer) {
            if (a.nummer > b.nummer) return 1
            if (a.nummer < b.nummer) return -1
        }

        if (a.bokstav != null && b.bokstav != null && a.bokstav != b.bokstav) {
            if (a.bokstav > b.bokstav) return 1
            if (a.bokstav < b.bokstav) return -1
        }

        if (a.bolignummer != null && b.bolignummer != null && a.bolignummer != b.bolignummer) {
            var aBolignummer = parseInt(a.bolignummer.match(/\d+/)[0])
            var bBolignummer = parseInt(b.bolignummer.match(/\d+/)[0])
            if (aBolignummer > bBolignummer) return 1
            if (aBolignummer < bBolignummer) return -1
        }
        

        if (a.borettslagAndelsnummer != null && b.borettslagAndelsnummer != null && a.borettslagAndelsnummer != b.borettslagAndelsnummer) {
            if (a.borettslagAndelsnummer > b.borettslagAndelsnummer) return 1
            if (a.borettslagAndelsnummer < b.borettslagAndelsnummer) return -1
        }

        return 0
    }

    toggleBoretter = () => {
        if (!this.state.isBoretterLoaded) {
            this.getBoretter()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        return (
            <li>
                <div className="section-header" onClick={this.toggleBoretter}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={EierforholdIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('boretter')} {this.state.isBoretterLoaded && `(${this.state.boretter.length})`}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.boretter.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.boretter.map((e, index) => {return (<Borett key={e.registerenhetsrettsandelId} borett={e} antall={this.state.boretter.length} isLast={index==this.state.boretter.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} settings={this.props.settings} token={this.props.token} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getBoretter}>
                                <span>{t('hent.boretter')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(BorettList)